import { isSSO } from "App/constants";
import { getToken, getUserName } from "App/utils/cookies";
import { isNull } from "App/utils/helpers";
import React from "react";
import { Route, Redirect } from "react-router-dom";

const RedirectLoginPage = () => {
  React.useEffect(() => {
    window.location.replace(process.env.REACT_APP_SSO_LOGIN_PAGE);
  }, []);

  return <></>;
};

function ProtectedRoutes({ path, children, ...others }) {
  const token = getToken();
  const userName = getUserName();
  if (isNull(userName)) {
    if (isSSO) {
      return <RedirectLoginPage />;
    } else {
      return <Redirect to='/' />;
    }
  }

  if (!isNull(token)) {
    return (
      <Route path={path} {...others}>
        {children}
      </Route>
    );
  } else {
    if (isSSO) {
      return <RedirectLoginPage />;
    } else {
      return <Redirect to='/' />;
    }
  }
}

export default ProtectedRoutes;
